module.exports = __webpack_public_path__ + "img/logo.c8a76b5e.png";